import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "medication",
  templateUrl: "medication.html",
})
export class MedicationComponent implements OnInit {
  name: string;
  dosage: string;
  frequency: string;
  state: string;
  records: any[] = [];

  expanded: boolean = false;

  @Input() data: any = {};
  @Output() newMAR: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    // this.name = this.data.name;
    // this.dosage = this.data.dosage;
    // this.frequency = this.data.frequency;
    this.state = this.data.orderStatus === "OP" ? "Open" : "Active";
    this.records = this.data.records;

    console.log(this.records);
  }

  relayMARData(data) {
    this.newMAR.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/medication/medication.ts